module.exports = __webpack_public_path__ + "media/images/sports_icons/figure-skating-6a915bb0449b1f800cf14283095ca9e3.png";